import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { WhatsAppConfigCreateRequestDTO, WhatsappConfigDeleteRequestDTO, WhatsAppConfigDTO, WhatsAppConfigReadAllPaginatedRequestDTO, WhatsappConfigUpdateRequestDTO } from './whatsapp-config.interface';
import { environment } from 'src/environments/environment';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { WhatsappConfigService } from './whatsapp-config.service';
import { ConfirmmodalserviceService } from 'src/app/Shared/confirm-delete-modal/confirmmodalservice.service';
import { pushOne } from '@amcharts/amcharts5/.internal/core/util/Array';
import { ActivatedRoute, Router } from '@angular/router';
import { ensureNumber, ensureString } from 'src/app/Shared/customFunctions/CustomFunctions';

@Component({
  selector: 'app-whatsapp-config',
  templateUrl: './whatsapp-config.component.html',
  styleUrls: ['./whatsapp-config.component.css']
})
export class WhatsappConfigComponent {

  // Flags
  isLoading: boolean = false;
  isSubmitting: boolean = false;


  // Services 
  User = inject(UserLoginService).User();
  private whatsAppConfigService = inject(WhatsappConfigService)
  modalService = inject(NgbModal)
  private confirmModal = inject(ConfirmmodalserviceService);
  router = inject(Router);
  route = inject(ActivatedRoute);
  // Items 
  whatsAppConfigList: WhatsAppConfigDTO[] = []

  @ViewChild('whatsappConfigModalContent', { static: false }) whatsappConfigModalContent!: ElementRef;
  addWhatsappConfigModal!: NgbModalRef;





  whatsappConfigForm = new FormGroup({
    iName: new FormControl('', [Validators.required]),
    iDesc: new FormControl(''),
    waUrl: new FormControl('', [Validators.required]),
    userAccessToken: new FormControl('', [Validators.required]),
    waConfigId: new FormControl(0),
    mProduct: new FormControl(''),
    iType: new FormControl(''),
    companyId: new FormControl(0),
    branchId: new FormControl(0),
    softwareId: new FormControl(0),
    actionUser: new FormControl(''),
    isActive: new FormControl(0),
    isDeleted: new FormControl(0),
    createdBy: new FormControl(''),
    createdOn: new FormControl(''),
    modifiedBy: new FormControl(''),
    modifiedOn: new FormControl(''),
    versionNo: new FormControl(''),
    phoneNo: new FormControl(''),
    phoneNoId: new FormControl(''),
    wabaId: new FormControl('')

  })

  PaginatedDTO: WhatsAppConfigReadAllPaginatedRequestDTO = {
    tenantId: ensureNumber(this.User.companyId),
    tenantBranchId: ensureNumber(this.User.loggedInBranchId),
    softwareId: ensureNumber(environment.SoftwareId),
    pageNo: 1,
    pageSize: 10

  }


  ngOnInit(): void {
    this.getWhatsAppConfigList(this.PaginatedDTO);
  }



  openWhatsappConfigForm() {
    this.whatsappConfigForm.reset();
    this.addWhatsappConfigModal = this.modalService.open(this.whatsappConfigModalContent)

    this.whatsappConfigForm.patchValue({
      companyId: ensureNumber(this.User.companyId),
      branchId: ensureNumber(this.User.loggedInBranchId),
      softwareId: ensureNumber(environment.SoftwareId),
      actionUser: ensureString(this.User.userId),
    });
  }

  submitWhatsappConfigForm() {
    this.whatsappConfigForm.markAllAsTouched();
    if (this.whatsappConfigForm.valid) {
      this.isSubmitting = true;
      const formData = { ...this.whatsappConfigForm.value };
      let data: WhatsappConfigUpdateRequestDTO = {
        waConfigId: ensureNumber(formData.waConfigId),
        isActive: 1,
        tenantId: ensureNumber(this.User.companyId),
        tenantBranchId: ensureNumber(this.User.loggedInBranchId),
        softwareId: 1,
        iName: ensureString(formData.iName),
        iDesc: ensureString(formData.iDesc),
        waUrl: ensureString(formData.waUrl),
        versionNo: ensureString(formData.versionNo),
        phoneNo: ensureString(formData.phoneNo),
        phoneNoId: ensureString(formData.phoneNoId),
        userAccessToken: ensureString(formData.userAccessToken),
        wabaId: ensureString(formData.wabaId),
        actionUser: ensureString(this.User.userId)
      };

      if (formData.waConfigId && formData.waConfigId !== 0) {
        this.updateWhatsappConfig(data);
      } else {
        this.createWhatsappConfig(data);
      }
    }

  }

  handleActionClick(event: { actionName: string, rowData: WhatsAppConfigDTO }) {
    const formData = event.rowData

    if (event.actionName === 'Delete') {
      this.confirmModal.openDeleteModal(formData.iName!, formData).subscribe(res => {

        if (res) {
          let data: WhatsappConfigDeleteRequestDTO = {
            waConfigId: ensureNumber(formData.waConfigId),
            tenantId: ensureNumber(formData.tenantId),
            tenantBranchId: ensureNumber(formData.tenantBranchId),
            actionUser: ensureString(this.User.userId)
          };

          this.deleteWhatsAppConfig(data)
        }
      })
    }
    // else if (event.actionName === 'View') {
    //   this.router.navigate(["/notification/whatsapptemplate"]);
    // }
    if (event.actionName === 'View') {
      const id = event.rowData.waConfigId;
      this.router.navigate(['/notification/whatsapptemplate', event.rowData.waConfigId]);
    }

    if (event.actionName === 'Edit') {
      this.whatsappConfigForm.patchValue({
        waConfigId: ensureNumber(formData.waConfigId),
        companyId: ensureNumber(formData.tenantId),
        branchId: ensureNumber(formData.tenantBranchId),
        softwareId: ensureNumber(formData.softwareId),
        iName: ensureString(formData.iName),
        iDesc: ensureString(formData.iDesc),
        waUrl: ensureString(formData.waUrl),
        userAccessToken: ensureString(formData.userAccessToken),
        phoneNo: ensureString(formData.phoneNo),
        phoneNoId: ensureString(formData.phoneNoId),
        actionUser: ensureString(this.User.userId),
      })
      this.addWhatsappConfigModal = this.modalService.open(this.whatsappConfigModalContent);
    }
  }

  handlePageSizeChange(event: { currentPage: number; pageSize: number; }) {
    this.PaginatedDTO.pageNo = event.currentPage;
    this.PaginatedDTO.pageSize = event.pageSize;
    this.getWhatsAppConfigList(this.PaginatedDTO)

  }



  // Database Fucntions 
  getWhatsAppConfigList(data: WhatsAppConfigReadAllPaginatedRequestDTO) {
    this.isLoading = true;
    this.whatsAppConfigService.WhatsAppConfig_readAllPaginated(data).subscribe({
      next: (response) => {
        this.whatsAppConfigList = response.items;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error fetching whatsapp config list:', err);
        this.isLoading = false;
      }
    })
  }

  createWhatsappConfig(data: WhatsAppConfigCreateRequestDTO): void {
    this.whatsAppConfigService.WhatsAppConfig_create(data).subscribe({
      next: (res) => {
        this.addWhatsappConfigModal.close()
        this.getWhatsAppConfigList(this.PaginatedDTO);
        this.isSubmitting = false;
      },
      error: (err) => {
        console.log('error creating whatsapp config:', err);
        this.isSubmitting = false;
      }
    })
  }

  updateWhatsappConfig(data: WhatsappConfigUpdateRequestDTO): void {
    this.whatsAppConfigService.WhatsAppConfig_update(data).subscribe({
      next: (res) => {
        this.addWhatsappConfigModal.close();
        this.getWhatsAppConfigList(this.PaginatedDTO);
        this.isSubmitting = false;
      },
      error: (err) => {
        this.isSubmitting = false;
      }
    });
  }

  deleteWhatsAppConfig(data: WhatsappConfigDeleteRequestDTO) {

    this.whatsAppConfigService.WhatsAppConfig_delete(data).subscribe({
      next: () => {
        this.getWhatsAppConfigList(this.PaginatedDTO);
      }
    });
  }
}
